<template>
  <div>
    <v-container class="bid-alerts-view grid-list-md pl-3 pr-3 pb-5" style="padding-top: 70px;max-width: 1442px;">
      <v-layout row wrap mt-2 align-center>
        <v-flex xs12 class="page-header-body">
          <h1
            style="color:#4a4a4a;font-size:29px;font-weight:bolder;text-justify:auto;margin:0px;"
            class="page-header">
            Federal Bid Alert Settings
          </h1>
          <div style="padding-top:0px;">
            <p
              style="text-justify:auto;line-height:22px;margin:0px;"
              class="page-header-subtext page-subtitle">
              Use the options below to setup your Federal Bid Email Alert Settings.
            </p>
          </div>
        </v-flex>
        <v-flex
          v-if="loadingAlerts"
          xs12
          class="flex-center pa-4">
          <v-progress-circular
            size="80"
            indeterminate/>
        </v-flex>
        <v-flex
          v-else
          xs12
          mt-3
          style="padding: 4px;">
          <v-btn
            class="ma-0"
            @click="savingSettings">Save settings</v-btn>
        </v-flex>
      </v-layout>
      <v-layout
        v-if="!loadingAlerts"
        row
        wrap>
        <v-flex
          xs12
          sm6
          md4>
          <BidAlertSelect
            v-model="filters.agency"
            label="Agency"
            :items="agencies"/>
        </v-flex>
        <v-flex
          xs12
          sm6
          md4>
          <BidAlertSelect
            v-model="filters.naics"
            label="NAICS"
            :items="naicsCodes"/>
        </v-flex>
        <v-flex
          xs12
          sm6
          md4>
          <BidAlertSelect
            v-model="filters.psc"
            label="PSC"
            :items="pscCodes"/>
        </v-flex>
        <v-flex
          xs12
          sm6
          md4>
          <BidAlertSelect
            v-model="filters.setAside"
            label="Set-Aside"
            :items="setAsides"/>
        </v-flex>
        <v-flex
          xs12
          sm6
          md4>
          <BidAlertSelect
            v-model="filters.noticeType"
            label="Notice Type"
            :items="noticeTypes"/>
        </v-flex>
        <v-flex
          xs12
          sm6
          md4>
          <BidAlertSelect
            v-model="filters.pointOfContact"
            label="Point Of Contact"
            :items="pointOfContacts"
            :uri="pointOfContactURI"
            async/>
        </v-flex>
        <v-flex
          xs12
          sm6
          md4
          class="keywords-box">
          <!-- <v-textarea
            v-model="filters.keywords"/> -->
          <v-select
            v-model="filters.keywords"
            chips
            autocomplete
            placeholder="Keywords (Type keyword and press enter to add)"
            solo
            tags
            multiple>
            <template slot="selection" slot-scope="data">
              <v-chip
                v-if="data.item"
                :selected="data.selected"
                label
                small>
                <span class="pr-2">
                  {{ data.item }}
                </span>
                <v-icon
                  small
                  @click="data.parent.selectItem(data.item)"
                >close</v-icon>
              </v-chip>
            </template>
          </v-select>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import axios from 'axios'
import BidAlertSelect from '@/components/bidAlertSelect'
import agencyList from './constants/fed-agencies.json'
import naicsCodes from './constants/NAICSCode.json'
import pscCodes from './constants/PSCCode.json'

export default {
  layout: 'page',
  components: {
    BidAlertSelect
  },
  data () {
    return {
      keywords: [],
      headers: [
        {
          text: 'Alert Type',
          value: 'alert_type',
          align: 'left',
          sortable: false
        },
        {
          text: 'Search Parameters',
          value: 'search',
          align: 'left',
          sortable: false
        },
        {
          text: 'Created Date',
          value: '',
          align: 'left',
          sortable: false
        },
        {
          text: 'Last Sent Date',
          value: '',
          align: 'left',
          sortable: false
        },
        {
          text: 'Next Send Date',
          value: '',
          align: 'left',
          sortable: false
        },
        {
          text: 'Action',
          value: '',
          align: 'left',
          sortable: false
        }
      ],
      agencies: agencyList.map(val => {
        return {
          text: val.name,
          value: val.name
        }
      }),
      naicsCodes: naicsCodes.map(val => {
        return {
          text: `${val.naicscode} - ${val.naicscodedescription}`,
          value: val.naicscode
        }
      }),
      pscCodes: pscCodes.map(val => {
        return {
          text: `${val.psccode} - ${val.psccodedescription}`,
          value: val.psccode
        }
      }),
      setAsides: [
        'Total Small Business',
        'Competitive 8(a)',
        'Veteran-Owned Small Business',
        'Woman Owned Small Business',
        'Hubzone',
        'Economically Disadvantaged Woman Owned Small Business',
        'Indian Small Business Economic Enterprises',
        'Indian Economic Enterprises',
        'Emerging Small Business',
        'Partial Small Business',
        'Very Small Business'
      ].map(val => {
        return {
          text: val,
          value: val.toLowerCase().split(' ').join('~')
        }
      }),
      noticeTypes: [
        'Combined Synopsis/Solicitation',
        'Presolicitation',
        'Solicitation',
        'Sources Sought'
      ].map(val => {
        return {
          text: val,
          value: val.toLowerCase().split(' ').join('~')
        }
      }),
      pointOfContacts: [],
      pointOfContactURI: null,
      alertData: {},
      filters: {
        agency: [],
        naics: [],
        psc: [],
        setAside: [],
        noticeType: [],
        pointOfContact: [],
        keywords: []
      },
      searchParameters: {
        agency: 'Agency',
        naics: 'NAICS',
        psc: 'PSC',
        keywords: 'Keywords',
        setAside: 'Set-Aside',
        noticeType: 'Notice Type',
        pointOfContact: 'Point Of Contact'
      },
      loadingAlerts: true,
      alerts: []
    }
  },
  computed: {
    pageData () {
      return this.$store.getters.getSettings.pages
    },
    styles () {
      return this.$store.getters.getStyles
    },
    user () {
      return this.$store.getters.getUserDetails
    }
  },
  mounted () {
    this.getAlerts()
  },
  methods: {
    async getAlerts () {
      try {
        this.loadingAlerts = true
        const user = this.user
        const snapshot = await this.$firebase
          .firestore()
          .collection('bid_alert_preferences')
          .doc(user.uid)
          .get()
        await this.getPOC()
        const data = snapshot.data() || {}

        this.alertData = data
        const federalData = data.federal || {}

        for (var key in this.filters) {
          this.$set(this.filters, key, federalData[key] || [])
        }

        this.loadingAlerts = false
      } catch (err) {
        console.log('err', err)
      }
    },
    async savingSettings () {
      try {
        const { uid } = this.user
        const firestore = this.$firebase.firestore()
        const createdDate = this.alertData.federal ? this.alertData.federal.created_date : Date.now()
        const lastSentDate = this.alertData.federal ? this.alertData.federal.last_sent_date : null
        const nextAlertDate = this.alertData.federal ? this.alertData.federal.next_alert_date : null

        const searchParametes = Object.keys(this.filters || {}).map(key => {
          const keyValueLength = this.filters[key].length
          const parameter = this.searchParameters[key]
          return `${parameter}: ${keyValueLength === 1
            ? `${keyValueLength} value selected.` : `${keyValueLength} values selected.`}`
        })

        const data = {
          ...this.filters,
          created_date: createdDate,
          last_sent_date: lastSentDate,
          next_alert_date: nextAlertDate,
          search_parameters: searchParametes
        }

        await firestore
          .collection('bid_alert_preferences')
          .doc(uid)
          .set({
            federal: data
          }, { merge: true })

        this.alertData = data

        let snackbar = {
          active: true,
          text: 'Your bid alert settings was saved successfully.'
        }

        return this.$store.commit('triggerSnackbar', snackbar)
      } catch (err) {
        console.log(err, 'err')
        let snackbar = {
          active: true,
          text: 'An error occurred while saving your bid alert settings.'
        }

        return this.$store.commit('triggerSnackbar', snackbar)
      }
    },
    async getPOC () {
      try {
        const uri = 'https://us-central1-defense-exchange.cloudfunctions.net/api/opportunities/poc'
        this.pointOfContactURI = uri
        const { data } = await axios.get(uri)

        this.pointOfContacts = data.map(item => {
          return {
            text: item.pointofcontact,
            value: item.pointofcontactemail || item.pointofcontactphonenum || item.pointofcontact
          }
        }).filter(item => {
          return item.text.length && item.value.length
        })
        return
      } catch (error) {
        console.log('Err in getPOC =>', error)
      }
    },
    async addKeyword (e) {
    //   console.log(e)
    //   this.keywords.push(e.target.value)
    //   await this.$nextTick()
    //   this.$set(this.filters, 'keywords', [
    //     ...this.filters.keywords,
    //     e.target.value
    //   ])
    }
  }
}
</script>

<style scoped lang="scss">
  .text--underline {
    text-decoration: underline;
  }
  .flex-center {
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
<style lang="scss">
  .keywords-box {
    .input-group__input {
      background: #fff !important;
    }
    .input-group--select {
      margin: 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// ManageFederalBidAlertView.vue?846adcdc